var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0711 17.0711C13.1658 20.9763 6.83418 20.9763 2.92893 17.0711C-0.976311 13.1658 -0.976311 6.83418 2.92893 2.92893C6.83418 -0.976311 13.1658 -0.976311 17.0711 2.92893C20.9763 6.83418 20.9763 13.1658 17.0711 17.0711Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7123 6.28773C11.6621 4.23748 8.33794 4.23748 6.28769 6.28773C4.99696 7.57847 4.51803 9.37396 4.85368 11.0415L3.38318 11.3375C2.95265 9.1986 3.56634 6.88776 5.22703 5.22707C7.86307 2.59103 12.1369 2.59103 14.773 5.22707L13.7123 6.28773Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28769 13.7123C8.33794 15.7625 11.6621 15.7625 13.7123 13.7123C15.003 12.4215 15.482 10.626 15.1463 8.95845L16.6168 8.66247C17.0474 10.8014 16.4337 13.1122 14.773 14.7729C12.1369 17.409 7.86307 17.409 5.22703 14.7729L6.28769 13.7123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.f5bea5fefa9e38a0346a8c354856edb1.svg";
export { ForwardRef as ReactComponent };